import React, { useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { parseURLSearchParams } from 'shared-components/src/utils/string';
import { resetPassword as resetPasswordAPI, login } from '../../../../utils/auth';
import ResetPassword from './ResetPassword';
import { isPasswordValid } from '../../../../utils/validations';

function ResetPasswordContainer(props) {
  const { updateLoading, updateUser, updateError, password, passwordConfirm, updateFormError, user } = props;
  const navigate = useNavigate();
  const location = useLocation();

  // Lifecycle effect - replaces componentDidMount
  useEffect(() => {
    const params = parseURLSearchParams(location.search);
    const { pwt } = params;

    if (pwt) {
      fetch(`/api/v1/reset_password?token=${pwt}`)
        .then(res => res.json())
        .then(body => {
          body.error
            ? updateError(body.error.message)
            : updateUser({ ...body.data.user, token: pwt });
          updateLoading(false);
        })
        .catch(err => {
          updateError('Unable to contact Pungle Platform');
          updateLoading(false);
        });
    } else {
      updateLoading(false);
      updateError('Unable to validate email link');
    }
  }, [location.search, updateLoading, updateUser, updateError]);

  // Handler - replaces withHandlers
  const resetPassword = useCallback(async (e) => {
    e.preventDefault();

    if (!isPasswordValid(password.trim())) {
      updateFormError(
        '<p><b>Password does not meet requirements</b></p><br/> <ul> <li style="list-style-type:disc;margin-left:15px">Password must be at least 12 characters</li><li style="list-style-type:disc;margin-left:15px">Must contain one capital letter</li><li style="list-style-type:disc;margin-left:15px">Must contain one number</li><li style="list-style-type:disc;margin-left:15px">Must contain one symbol (ex: ! @ # $ *)</li></ul>'
      );
      return;
    }

    if (password !== passwordConfirm) {
      updateFormError('Passwords do not match');
      return;
    }

    // Create initial body here
    const payload = { token: user.token, email: user.email, password };

    try {
      updateLoading(true);
      await resetPasswordAPI(payload);
      await login(user.email, password);
    } catch (error) {
      updateLoading(false);
      updateFormError(error.message);
    }
  }, [password, passwordConfirm, user, updateFormError, updateLoading]);

  return <ResetPassword {...props} resetPassword={resetPassword} history={navigate} />;
}

export default ResetPasswordContainer;
